// 暂时使用简单的直线拟合, 简单高效
// 虽然曲线拟合不够平滑, 但是在大多数情况下足够了
// 主要是边缘点集比较全，拟合效果也挺好
import { Command, CommandParams, CommandType } from '../type/common.interface';

function createCommand<T extends CommandType>(type: T, params?: Omit<CommandParams<T>, 'type'>): CommandParams<T> {
    return { type, ...params } as unknown as CommandParams<T>;
}

export const generate = (points: { x: number; y: number }[]): Command[] => {
    if (points.length < 2) return [];

    const commands: any[] = [];

    commands.push(createCommand('M', {
        x: points[0].x,
        y: points[0].y,
    }));

    for (let i = 1; i < points.length; i++) {
        commands.push(createCommand('L', {
            x: points[i].x,
            y: points[i].y,
        }));
    }

    commands.push(createCommand('L', {
        x: points[0].x,
        y: points[0].y,
    }));

    return commands;
};
